import React, { useEffect, useState } from "react";
import CurrencyInput from "react-currency-masked-input";
import {
  ModalOverlay,
  ModalBox,
  ModalTitle,
  ModalInput,
  ModalValues,
  ModalActions,
  ConfirmButton,
  CancelButton,
} from "./style";

const ModalSeller = ({ isOpen, onClose, onConfirm, acrescimoPadrao = 0.0, freteSelecionado }) => {
  const [acrescimoInput, setAcrescimoInput] = useState("");

  useEffect(() => {
    setAcrescimoInput(acrescimoPadrao.toFixed(2).replace(".", ","));
  }, [acrescimoPadrao]);

  const parseValue = () => {
    const value = parseFloat(acrescimoInput.replace(",", "."));
    return isNaN(value) || value < 0 ? 0 : parseFloat(value.toFixed(2));
  };

  const valorAcrescimo = parseValue();

  const formatReal = (value) => (value || 0).toFixed(2).replace(".", ",");

  const total = () => formatReal((freteSelecionado?.valorFrete || 0) + valorAcrescimo);

  const onConfirmAcrescimo = () => {
    onConfirm(freteSelecionado, valorAcrescimo);
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalBox>
        <ModalTitle>Valor a ser acrescido ao frete:</ModalTitle>

        <ModalValues>
          <p>Frete:</p>
          <p className="money-sign">
            R$
            <ModalInput
              type="text"
              value={formatReal(freteSelecionado?.valorFrete)}
              placeholder="0,00"
              disabled={true}
            />
          </p>
        </ModalValues>

        <ModalValues>
          <p>Acréscimo:</p>
          <p className="money-sign">
            R$
            <ModalInput
              as={CurrencyInput}
              type="text"
              separator=","
              value={acrescimoInput}
              onChange={(e, valorNovo) => setAcrescimoInput(valorNovo)}
              placeholder="0,00"
            />
          </p>
        </ModalValues>

        <ModalValues>
          <p>Total:</p>
          <p className="money-sign">
            R$
            <ModalInput type="text" value={total()} placeholder="0,00" disabled={true} />
          </p>
        </ModalValues>

        <ModalActions>
          <CancelButton onClick={onClose}>Cancelar</CancelButton>
          <ConfirmButton onClick={onConfirmAcrescimo}>Confirmar</ConfirmButton>
        </ModalActions>
      </ModalBox>
    </ModalOverlay>
  );
};

export default ModalSeller;
